import React, { Component } from "react";
import { Container, Row, Col, Card, Table } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import { toast } from 'react-toastify';
import {
  Loading,
  ButtonAdd,
  ButtonEdit,
  ButtonDelete
} from "../../../components";
import FormMusica from "./FormMusica";

import api from "../../../services/api";

const emptyRecord = { id: '', musica: '', nivel: '' };

class Musicas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showModal: false,
      records: [],
      totalRecords: 0,
      record: emptyRecord
    };
  }

  loadFromAPI = () => {
    this.setState({ isLoading: true }, () => {
      api.get('/musicas')
        .then(response => {
          this.setState({
            records: response.data.musicas ? response.data.musicas : [],
            totalRecords: response.data.musicas ? response.data.musicas.length : 0,
            isLoading: false
          });
        })
        .catch(error => {
          this.setState({ isLoading: false });
          toast.error('Falha ao obter dados!');
        });
    });
  };

  doDelete = (id) => {
    api.delete('/musicas', { data: { id: id } })
      .then((response) => {
        if (response.data.message === 'ok') {
          toast.success('Música excluida com sucesso!');
          this.loadFromAPI();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error('Ocorreu uma falha ao excluir!');
      });
  };

  openModalForm = (record) => {
    this.setState({
      showModal: true,
      record: record
    });
  };

  closeModalForm = () => {
    this.setState({
      showModal: false,
      record: emptyRecord
    });
  };

  componentDidMount = () => {
    this.loadFromAPI();
  };

  render() {
    const { isLoading, showModal, totalRecords, records, record } = this.state;

    return (
      <Container fluid>
        <Row className="mb-4">
          <Col><h1 className="page-title">Músicas</h1></Col>
          <Col sm="auto" className="pt-3 pt-sm-2">
            <ButtonAdd label="Adicionar musica" onClick={() => this.openModalForm(emptyRecord)} />
          </Col>
        </Row>

        <Card className="card-list">
          <Card.Body className="p-0">
            <div className="loading">
              <div className="nowrap mx-3 py-2">Total: <b>{totalRecords}</b> registro(s).</div>
              <Table striped responsive className="table-data">
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: "25px" }}>#</th>
                    <th>Nome da Música</th>
                    <th className="text-center">Nível</th>
                    <th className="text-center">Alunos</th>
                    <th style={{ width: "76px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {!records.length ? (
                    <tr><td colSpan={5} className="empty">Nenhum registro </td></tr>
                  ) : (
                      records.map((musica, key) => {
                        return (
                          <tr key={key}>
                            <td><span className="text-muted">{key + 1}</span></td>
                            <td><b>{musica.musica}</b></td>
                            <td className="text-center">{musica.nivel}</td>
                            <td className="text-center">{musica.alunos}</td>
                            <td className="text-right">
                              <ButtonEdit onClick={() => this.openModalForm(musica)} />
                              <ButtonDelete id={musica.id} label={musica.musica} doDelete={this.doDelete} />
                            </td>
                          </tr>
                        )
                      })
                    )}
                </tbody>
              </Table>
              <CSSTransition in={isLoading} timeout={500} classNames="fade" unmountOnExit>
                <div><Loading /></div>
              </CSSTransition>
            </div>
          </Card.Body>
        </Card>
        <br />
        <FormMusica
          emptyRecord={emptyRecord}
          record={record}
          showModal={showModal}
          loadFromAPI={this.loadFromAPI}
          closeModalForm={this.closeModalForm}
        />
      </Container>
    );
  }
}

export default Musicas;